import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import DonutChart from '../SemiDonutChart';
import medalIcon from '../imgs/medal_icon.png';
import targetIcon from '../imgs/target_icon.png';

const StrategyScalesDescriptionCont = ({ user, background, number }) => {
  // sub-scales
  const { ES_SUB_SUM, EL_SUB_SUM } = user;

  // const AP_SUB = (parseInt(AP_SUB_SUM) / 30) * 100;
  const ES_SUB = (parseInt(ES_SUB_SUM) / 30) * 100;
  const EL_SUB = (parseInt(EL_SUB_SUM) / 30) * 100;
  // console.log({ AP_SUB, ES_SUB, EL_SUB });

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3 style={{ marginBottom: 6 }}>
            2.2.2. Estrategias de aprendizaje instrumental
          </h3>
          <div className='graph-in-text'>
            <div className='chart-col'>
              <div
                className='ability-icon'
                style={{
                  height: 150,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={targetIcon}
                  alt='icon'
                  style={{ height: '100%', width: 'auto' }}
                />
              </div>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
              <DonutChart
                height={120}
                barSize={42}
                fontSize={36}
                data={[
                  {
                    id: 'ES_SUB',
                    label: ES_SUB.toFixed(0) + '%',
                    value: ES_SUB,
                    color: '#f7c033'
                  }
                ]}
              />
              <p className='justified'>
                Estas estrategias tienden a{' '}
                <strong>enfocarse sólo en lo que será evaluado</strong>. Por
                ejemplo, se aprenden cosas “de memoria”, o se repasan
                rápidamente justo antes de una prueba. Además se tienden a
                evitar estrategias de estudio que requieren más esfuerzo, como
                hacer mapas mentales o autoevaluar lo que se ha aprendido. Este
                tipo de estrategias pueden parecer útiles en algunos momentos
                (como cuando una materia no nos gusta o se nos hace difícil),
                pero pueden ser una barrera para aprender de verdad. El
                aprendizaje que se logra con estas estrategias suele ser frágil,
                y es común sentir inseguridad o estrés antes de una evaluación,
                al no tener claridad sobre cuánto se ha comprendido.{' '}
                <strong>
                  Si obtuviste un puntaje alto en esta escala, puede ser un buen
                  momento para revisar tus hábitos de estudio y comenzar a
                  incorporar estrategias más activas, que te ayuden a aprender
                  de mejor forma.
                </strong>
              </p>
            </div>
          </div>

          <br />

          <h3 style={{ marginBottom: 6 }}>
            2.2.3. Estrategias de logro académico
          </h3>
          <div className='graph-in-text'>
            <div className='chart-col'>
              <div
                className='ability-icon'
                style={{
                  height: 150,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={medalIcon}
                  alt='icon'
                  style={{ height: '100%', width: 'auto' }}
                />
              </div>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
              <DonutChart
                height={120}
                barSize={42}
                fontSize={36}
                data={[
                  {
                    id: 'EL_SUB',
                    label: EL_SUB.toFixed(0) + '%',
                    value: EL_SUB,
                    color: '#f7c033'
                  }
                ]}
              />
              <p className='justified'>
                Se relaciona con estrategias orientadas a organizar el estudio
                para alcanzar nuestros objetivos académicos, como por ejemplo
                buscar un lugar de estudio que permita concentrarse mejor,
                planificar los tiempos de estudio, o hacer las tareas con tiempo
                para que no se acumule el trabajo. Este tipo de estrategias
                ayuda a disminuir la ansiedad relacionada con las exigencias del
                colegio, ya que permiten organizar de mejor forma los tiempos de
                estudio, y es deseable que todas y todos los/las estudiantes
                incorporen este tipo de estrategias en su repertorio.{' '}
                <strong>
                  Si estas estrategias no son parte de tu rutina, puedes
                  comenzar con pasos simples, como usar una agenda o calendario
                  para organizar tus tareas y fijar horarios de estudio en los
                  que puedas concentrarte mejor.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default StrategyScalesDescriptionCont;
